var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCopy = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    transform: "translate(2 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.5 27.5v-15h7l4 4v11z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#5b5b5c",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.5 12.5v4h4z",
    fill: "#f0f0f0",
    fillRule: "evenodd",
    stroke: "#5b5b5c",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8 17.5h6.5",
    stroke: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 19.5h7.5",
    stroke: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 21.5h5",
    stroke: "#6a6a6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 23.5h7",
    stroke: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 25.5h7",
    stroke: "#969696"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.5 27.5v-15h7l4 4v11z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#5b5b5c",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.5 12.5v4h4z",
    fill: "#f0f0f0",
    fillRule: "evenodd",
    stroke: "#5b5b5c",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#969696"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8 17.5h6.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 19.5h7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 21.5h5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 23.5h7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 25.5h7"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCopy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/copy.5f4232b2.svg";
export { ForwardRef as ReactComponent };